import IqosStardrift from './IqosStardrift';
export default IqosStardrift;
